import {className} from "../../misc/utils";

export class Exception {
    message = '';

    /**
     *
     * @param message {string}
     */
    constructor(message) {
        this.message = message;
    }

    static NotImplemented(message) {
      console.error(message || "Not implemented.");
    }

    static NotImplementedBaseClass(instance) {
      console.error(`Not implemented in base class ${className(instance)}`);
    }
}

